// import CloneDeep from 'lodash.clonedeep';
// import IsEqual from 'lodash.isequal';
let uid = 0;
export default class ErrorHandler {
	static NextUID() {
		uid++;
		return `uid-${uid}`;
	}
	constructor(data) {
		if (data == undefined) {
			data = {};
		}
		Object.assign(this, {
			error:data.error|null
		});
	}
	static HasConnectionError(error) {
		this.error = error;
		if (error) {
			if (error == "Error: Network Error") {
				return true;
			} else {
				return false;
			}
		} else {
			// if the error does not have any codes attached to it, it's likely the user is not logged in.
			// return true;
			return false;
		}
	}

	static HasAccessErrorCode(error) {
		this.error = error;
		if (error) {
			if (error.response) {
				if (error.response.status == 401) {
					return true;
				}
			}
		} else {
			// if the error does not have any codes attached to it, it's likely the user is not logged in.
			// return true;
			return false;
		}
		return false;
	}


	static HasLoginErrorCode(error) {
		this.error = error;
		if (error) {
			if (error.response) {
				if (error.response.status == 500) {
					alert("Error: " + error.response.status + " " + error.response.statusText);
					return true;
				} else {
					if (error.response.data) {
						if (error.response.data.error) {
							if (error.response.data.error.code == "error.notLoggedIn") {
								return true;
							} else {
								return false;
							}
						} else {
							// if the error does not have any codes attached to it, it's likely the user is not logged in.
							// return true;
							return false;
						}
					} else {
						return false;
						// return true;
					}
				}
			}
		} else {
			// if the error does not have any codes attached to it, it's likely the user is not logged in.
			// return true;
			return false;
		}
	}
	static RedirectToLogin() {
		if (this.error) {
			if (this.error.response.status == 500) {
				alert("Server Error:" + this.error.response.status);
			} else {
				if (this.HasLoginErrorCode(this.error)) {
					alert("You are logged out. Redirecting to Login.");
					window.location.href="/";
				} else {
					alert("Server Error:" + this.error.response.data.error.code);
				}
			}
		}
	}
}
